/**
 * Where the game's assets live at runtime.
 *
 * Empty env values (the default) give "assets/", which resolves relative to
 * index.html and works in dev, on the local game host and on Cloudflare.
 * Set VITE_ASSET_SERVER / VITE_GAME_FOLDER only for cross-origin asset hosting.
 *
 * Engine-agnostic: pass ASSET_ROOT to whatever your engine uses as its load
 * root (e.g. KAPLAY's loadRoot) or use assetUrl() directly.
 */
const server = import.meta.env.VITE_ASSET_SERVER ?? "";
const folder = import.meta.env.VITE_GAME_FOLDER ?? "";

export const ASSET_ROOT = `${server}${folder}assets/`;

export const DEBUG = import.meta.env.VITE_DEBUG === "true";

export function assetUrl(relativePath: string): string {
    return ASSET_ROOT + relativePath.replace(/^\/+/, "");
}